var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContenedorCampos',{attrs:{"titulo":_vm.titulo,"isObligatorio":_vm.Obligatorio,"error":_vm.error}},[_c('v-text-field',{attrs:{"disabled":_vm.bDeshabilitado,"outlined":"","dense":"","clearable":"","hide-details":""},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }